import PropTypes from 'prop-types';
import { Component } from 'react';

import styles from './Modal.scss';

class Modal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            open: props.open
        };

        this.close = this.close.bind(this);
    }

    componentWillUnmount() {
        document.body.style.overflowY = 'visible';
    }

    close() {
        if (this.props.onClose) {
            this.props.onClose();
        }
        this.setState({
            open: false
        }, () => { document.body.style.overflowY = 'visible'; });
    }

    open(data) {
        if (this.props.onOpen) {
            this.props.onOpen();
        }
        this.setState({
            open: true,
            data: data || null
        }, () => { document.body.style.overflowY = 'hidden'; });
    }

    callFuncOnData(func) {
        return func(this.state.data);
    }

    render() {
        if (!this.state.open) {
            return null;
        }
        const { title, children, fullWidth } = this.props;
        return (
            <div className={styles.Modal__container} data-cy="Modal">
                <div className={fullWidth ? styles.Modal__content_full : styles.Modal__content}>
                    <div className={title ? styles.Modal__header : styles.Modal__noHeader}>
                        <div className={styles.centerHeader}>
                            <span className={styles.Modal__title} data-cy="Modal-title">{title}</span>
                        </div>
                        <span className={styles.Modal__close} data-dismiss="modal" 
                            aria-label="Close" onClick={this.close}
                            data-cy="Modal-Close"></span>
                    </div>

                    <div className={styles.Modal__body} data-cy="Modal-children">
                        { children }
                    </div>

                </div>
            </div>
        );
    }
}

Modal.propTypes = {
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    title: PropTypes.string
};

export default Modal;